import Cookies from 'universal-cookie';
import {
  getAuthCookieRemovalTargets,
  getCookieDomainForName,
  getCookieSecureDefault,
  SHARED_AUTH_COOKIE_NAMES,
} from 'utils/cookieDomain';
import { hasAuthPayload, parseCookieValue, readAuthCookieFromDocument } from 'utils/authCookieRead';
import legacyCookieCleanup from 'utils/legacyCookieCleanup';

class Cookie {
  constructor() {
    this.cookies = new Cookies();
  }

  removeAuthCookie(name) {
    getAuthCookieRemovalTargets(name).forEach(options => {
      this.cookies.remove(name, options);
    });
  }

  set(name, value, overrideOptions = {}) {
    if (SHARED_AUTH_COOKIE_NAMES.has(name) && (!value || value === '')) {
      this.removeAuthCookie(name);
      return;
    }

    const domain = getCookieDomainForName(name);
    if (SHARED_AUTH_COOKIE_NAMES.has(name) && domain) {
      // Drop stale host-only copies left from the old cookie model.
      this.cookies.remove(name, { path: '/' });
    }

    const options = {
      path: '/',
      secure: getCookieSecureDefault(),
      sameSite: 'Lax',
      ...(domain ? { domain } : {}),
      ...overrideOptions,
    };

    try {
      this.cookies.set(name, typeof value === 'string' ? value : JSON.stringify(value), options);
    } catch {
      this.cookies.set(name, value, options);
    }
  }

  get(name) {
    if (SHARED_AUTH_COOKIE_NAMES.has(name)) {
      const fromDocument = readAuthCookieFromDocument(name);
      if (fromDocument) {
        return fromDocument;
      }

      const parsed = parseCookieValue(this.cookies.get(name));
      return hasAuthPayload(name, parsed) ? parsed : null;
    }

    try {
      return JSON.parse(this.cookies.get(name));
    } catch {
      return this.cookies.get(name);
    }
  }

  clear() {
    const all = this.cookies.getAll();
    Object.keys(all).forEach(key => {
      if (SHARED_AUTH_COOKIE_NAMES.has(key)) {
        this.removeAuthCookie(key);
        return;
      }
      this.cookies.set(key, '');
      this.cookies.remove(key);
    });

    legacyCookieCleanup();
  }
}

export default new Cookie();
